import { Alert } from 'antd';
import styled from 'styled-components';

export const InfoAlert = styled((props) => <Alert type="info" {...props} />)`
  background-color: #e6f7ff;
  border-color: #91d5ff;
  .anticon {
    color: #1890ff;
  }
`;
